import { Modal } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { ReactComponent as FlagIcon } from "@assets/icons/flag.svg";
import { ReactComponent as UserCheckedIcon } from "@assets/icons/user_checked.svg";
import { ReactComponent as CloseIcon } from "@assets/icons/close_bold.svg";
import React from "react";

type ModalFactFindEligibilityProps = {
  open: boolean;
  onClose(): void;
};

const ModalFactFindEligibility: React.FC<ModalFactFindEligibilityProps> = ({
  open,
  onClose,
}) => {
  const { width: sizeWidth } = useViewportSize();

  const cards = [
    {
      label: "Proof of PPSN",
      sublabel: "Personal Public Service Number",
      icon: <FlagIcon className="w-6 h-6" />,
    },
    {
      label: "Identity Document",
      sublabel: "A certificate that displays your birthday e.g identity card",
      icon: <UserCheckedIcon className="w-6 h-6" />,
    },
  ];

  return (
    <Modal
      size={sizeWidth > 1024 ? 410 : 343}
      centered
      withCloseButton={false}
      opened={open}
      onClose={() => {}}
      styles={{
        body: {
          padding: "0px",
        },
        content: {
          borderRadius: "16px",
        },
      }}
    >
      <div className="flex flex-col">
        <div className="flex items-center justify-between py-4 px-6">
          <span className="text-pn-headline-emphasis">Have Handy</span>
          <button onClick={onClose} className="btn-secondary-icon-xs w-fit">
            <CloseIcon className="w-4 h-4" />
          </button>
        </div>
        <div className="flex flex-col gap-y-4">
          {cards.map((item, index) => (
            <div key={index} className="p-4 flex items-center gap-x-4">
              <div className="w-10 h-10 rounded-full bg-pn_gray-200 flex items-center justify-center">
                {item.icon}
              </div>
              <div className="flex flex-col gap-y-1 flex-1">
                <span className="text-pn-body-large-emphasis">
                  {item.label}
                </span>
                <span className="text-pn-body-small-regular">
                  {item.sublabel}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};
export default ModalFactFindEligibility;
